import 'typeface-poppins';
import { createTheme } from '@mui/material';

import { gray, primary, secondary, white } from './colors';

export const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: primary[4],
    },
    divider: primary[7],
    background: {
      default: '#000D14',
    },
    text: {
      primary: white,
      secondary: gray[3],
    },
  },
  typography: {
    fontFamily: 'Poppins',
  },
  components: {
    MuiChip: {
      styleOverrides: {
        root: {
          backgroundColor: primary[7],
          textAlign: 'center',
          fontFamily: 'Inter',
          fontSize: '0.6875rem',
          fontStyle: 'normal',
          fontWeight: 500,
          lineHeight: '1rem',
          padding: '0.25rem 0.5rem',
        },
        icon: {
          fontSize: '1rem',
          color: primary[3],
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        text: {
          border: 'none',
          background: 'none',
          color: gray[3],
          ':hover': {
            color: primary[3],
            border: 'none',
            background: 'none',
          },
          ':disabled': {
            color: gray[8],
            border: 'none',
            background: 'none',
          },
        },
        outlined: {
          backgroundColor: 'transparent',
          border: 'solid 1px',
          borderColor: gray[3],
          color: gray[3],
          ':hover': {
            backgroundColor: 'transparent',
            borderColor: primary[3],
            color: primary[3],
          },
          ':disabled': {
            backgroundColor: 'transparent',
            borderColor: gray[8],
            color: gray[8],
          },
        },
        root: {
          fontSize: '11px',
          backgroundColor: gray[3],
          borderRadius: '99px',
          fontFamily: 'Inter',
          fontWeight: 500,
          lineHeight: '16px',
          textTransform: 'capitalize',
          letterSpacing: '0.5px',
          padding: '8px 12px',
          color: gray[9],
          ':hover': {
            backgroundColor: primary[2],
          },
          ':disabled': {
            backgroundColor: gray[8],
          },
        },
      },
    },
    MuiLink: {
      styleOverrides: {
        root: {
          fontFamily: 'Inter',
          color: gray[3],
          ':hover': {
            color: primary[3],
          },
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: gray[7],
          borderRadius: '8px',
          color: white,
        },
        arrow: {
          color: gray[7],
        },
      },
    },
    MuiMenu: {
      styleOverrides: {
        list: {
          backgroundColor: '#002649',
          width: '18rem',
          '&& .Mui-selected': {
            backgroundColor: '#001B33',
          },
          '&& .Mui-selected:hover': {
            backgroundColor: '#223D55',
          },
        },
      },
    },
    MuiListItemText: {
      styleOverrides: {
        root: {
          fontFamily: 'Inter',
          fontSize: '0.875rem',
          lineHeight: '1.25rem',
        },
      },
    },
  },
});

export const lightTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: secondary[6],
    },
    divider: gray[3],
    background: {
      default: white,
    },
    text: {
      primary: gray[5],
      secondary: gray[6],
    },
  },
  typography: {
    fontFamily: 'Poppins',
  },
  components: {
    MuiButton: {
      styleOverrides: {
        text: {
          border: 'none',
          background: 'none',
          color: gray[5],
          ':hover': {
            color: primary[6],
            border: 'none',
            background: 'none',
          },
          ':disabled': {
            color: gray[3],
            border: 'none',
            background: 'none',
          },
        },
        outlined: {
          backgroundColor: 'transparent',
          border: 'solid 1px',
          borderColor: gray[5],
          color: gray[5],
          ':hover': {
            backgroundColor: 'transparent',
            borderColor: secondary[6],
            color: secondary[6],
          },
          ':disabled': {
            backgroundColor: 'transparent',
            borderColor: gray[3],
            color: gray[3],
          },
        },
        root: {
          fontSize: '11px',
          backgroundColor: gray[5],
          borderRadius: '99px',
          fontFamily: 'Inter',
          fontWeight: 500,
          textTransform: 'capitalize',
          letterSpacing: '0.5px',
          lineHeight: '16px',
          padding: '12px 16px',
          color: white,
          ':hover': {
            backgroundColor: secondary[6],
          },
          ':disabled': {
            backgroundColor: gray[3],
          },
        },
      },
    },
    MuiLink: {
      styleOverrides: {
        root: {
          fontFamily: 'Inter',
          color: gray[5],
          ':hover': {
            color: secondary[6],
          },
        },
      },
    },
  },
});
